const SECRET_PATTERN=/service[_-]?role|secret[_-]?key|private[_-]?key|client[_-]?secret|password|recovery/i;

function decodeJwtPayload(value){
  const parts=String(value||'').split('.');
  if(parts.length!==3)return null;
  try{
    const payload=parts[1].replace(/-/g,'+').replace(/_/g,'/');
    const padded=payload.padEnd(Math.ceil(payload.length/4)*4,'=');
    return JSON.parse(globalThis.atob(padded));
  }catch{return null;}
}

function assertPublishableCredential(value){
  const key=String(value||'').trim();
  if(!key)return;
  if(/^(?:sb_secret_|service[_-]?role)/i.test(key)){
    throw new Error('Privileged Supabase credential is not allowed in the client');
  }
  const payload=decodeJwtPayload(key);
  if(payload?.role&&payload.role!=='anon'){
    throw new Error('Only a publishable/anon Supabase credential may be embedded in the client');
  }
}

export function validateClientConfig(input={}){
  const config={...input};
  for(const key of Object.keys(config)){
    if(SECRET_PATTERN.test(key))throw new Error(`Privileged configuration is not allowed in the client: ${key}`);
  }

  const environment=String(config.environment||'local');
  const appVersion=String(config.appVersion||'0.4.0');
  const supabaseUrl=String(config.supabaseUrl||'');
  const supabasePublishableKey=String(config.supabasePublishableKey||'');
  const releaseEndpoint=String(config.releaseEndpoint||'/api/release');
  const googleAuthEnabled=config.googleAuthEnabled===true;
  const appleAuthEnabled=config.appleAuthEnabled===true;

  if(supabaseUrl&&!/^https:\/\//i.test(supabaseUrl)){
    throw new Error('Configured Supabase URL must use HTTPS');
  }
  assertPublishableCredential(supabasePublishableKey);

  return Object.freeze({
    environment,
    appVersion,
    supabaseUrl,
    supabasePublishableKey,
    releaseEndpoint,
    googleAuthEnabled,
    appleAuthEnabled
  });
}

export function loadClientConfig(source=globalThis.__DYMISTRZ_CONFIG__||{}){
  return validateClientConfig(source);
}
